module.exports = __webpack_public_path__ + "source-sans-pro-v10-latin-ext_latin-700.3bb7b5ef5977478705c1.woff";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-700.woff
// module id = ../../../../../src/assets/accessibility/layout/fonts/source-sans-pro-v10-latin-ext_latin-700.woff
// module chunks = styles